import axios from "axios";
import { BASE_URL } from "../../Helper/Helper";

const RatingsState = {
  addRatings: async (requestOptions) => {
    // FETCH API CALL For all notes
    const response = await axios.post(
      `${BASE_URL}/api/v1/admin/create-ratings`,
      requestOptions,
      {
        headers: {
          "auth-token": localStorage.getItem("token"),
        },
      }
    );

    let datas = response.data.data;
    return datas;
  },

  getRatings: async () => {
    // FETCH API CALL For all notes
    const response = await axios.get(`${BASE_URL}/api/v1/admin/get-ratings`, {
      headers: {
        token: localStorage.getItem("token"),
      },
    });

    //console.log("response", response);
    let datas = response.data.data;
    //console.log("datas", datas);
    return datas;
  },

  getRatingsByProjectId: async (id) => {
    // FETCH API CALL For all notes
    const response = await axios.get(
      `${BASE_URL}/api/v1/admin/get-ratings-by-projectId/${id}`,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    //console.log("response", response);
    let datas = response.data.data;
    //console.log("datas", datas);
    return datas;
  },

  deleteRatings: async (id) => {
    // FETCH API CALL For all notes
    const response = await axios.delete(
      `${BASE_URL}/api/v1/admin/delete-ratings/${id}`,
      {
        headers: {
          "auth-token": localStorage.getItem("token"),
        },
      }
    );

    let datas = response.data.data;
    // console.log("datas", datas);
    return datas;
  },
};

export default RatingsState;
